import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M10 8v6a2 2 0 1 0 4 0v-6","key":"svg-1"}]]

const IconCircleLetterU = createReactComponent('outline', 'circle-letter-u', 'CircleLetterU', __iconNode);

export default IconCircleLetterU;